<template>
  <div>
    <!-- Tarjetas de funcionalidad -->
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <!-- Tarjeta 1: Nomina -->
        <div
          class="manual-card tile is-child"
          @click="redireccionar('NominaEmpleados')"
        >
          <div class="card-content" style="cursor: pointer">
            <h3 class="subtitle is-spaced">Nomina</h3>
            <h1 class="title" style="font-size: 20px">
              Registro, Edición de empleados
            </h1>
          </div>
        </div>

        <!-- Tarjeta 2: Gastos/Ingresos -->
        <div
          class="manual-card tile is-child"
          @click="redireccionar('GastosPagos')"
        >
          <div class="card-content" style="cursor: pointer">
            <h3 class="subtitle is-spaced">Gastos/Ingresos</h3>
            <h1 class="title" style="font-size: 20px">
              Compras, Pago Provedores, etc
            </h1>
          </div>
        </div>

        <!-- Tarjeta 3: Proveedores -->
        <div
          class="manual-card tile is-child"
          @click="redireccionar('DatosProveedores')"
        >
          <div class="card-content" style="cursor: pointer">
            <h3 class="subtitle is-spaced">Proveedores</h3>
            <h1 class="title" style="font-size: 20px">
              Creación, edición e historial de proveedores
            </h1>
          </div>
        </div>

        <!-- Tarjeta 4: Aliados -->
        <div
          class="manual-card tile is-child"
          @click="redireccionar('DatosAliados')"
        >
          <div class="card-content" style="cursor: pointer">
            <h3 class="subtitle is-spaced">Aliados</h3>
            <h1 class="title" style="font-size: 20px">
              Creación, edición e historial de Aliados
            </h1>
          </div>
        </div>
      </div>
    </div>

    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />El periodo por
    defecto es el mes actual.

    <br />

    <!-- Columnas de resumen de finanzas -->
    <div class="columns is-desktop">
      <!-- Columna de Gastos -->
      <div class="column">
        <div class="box gastos-box">
          <p class="title is-4">
            Gastos ${{ parseInt(totalGastos).toLocaleString("es-CO") }}
          </p>
          <div id="contenedor-gastos">
            <canvas id="grafica-gastos"></canvas>
          </div>
        </div>
      </div>

      <!-- Columna de Ingresos -->
      <div class="column">
        <div class="box ingresos-box">
          <p class="title is-4">
            Ingresos ${{ parseInt(totalIngresos).toLocaleString("es-CO") }}
          </p>
          <div id="contenedor-ingresos">
            <canvas id="grafica-ingresos"></canvas>
          </div>
        </div>
      </div>
    </div>

    <br />

    <!-- Resumen de saldo -->
    <div class="column">
      <div
        class="box Saldo-box"
        :class="{ negative: nequi + efectivo + transferencia + tarjeta + nequiComercial < 0 }"
      ><b-button id="per" class="is-pulled-right" @click="showSwal"
      >Realizar Movimiento</b-button>
        <b-button id="per" class="is-pulled-right" @click="mostrarHistorial"
          >Ver historial</b-button
        >
        <p class="title is-2">
          Saldo ${{
            parseInt(nequi + efectivo + transferencia + tarjeta + nequiComercial).toLocaleString(
              "es-CO"
            )
          }}
        </p>
        <p class="title is-4">
  <table>
    <tr>
      <td><strong>Efectivo:</strong></td>
      <td>${{ parseInt(efectivo + efectivoMovimiento).toLocaleString("es-CO") }}</td>
    </tr>
    <tr>
      <td><strong>Nequi:</strong></td>
      <td>${{ parseInt(nequi + nequiMovimiento).toLocaleString("es-CO") }}</td>
    </tr>
    <tr>
      <td><strong>N Comercial:</strong></td>
      <td>${{ parseInt(nequiComercial + nequiComercialMovimiento).toLocaleString("es-CO") }}</td>
    </tr>
    <tr>
      <td><strong>Bancolombia :</strong></td>
      <td>${{ parseInt(tarjeta + tarjetaMovimiento).toLocaleString("es-CO") }}</td>
    </tr>
    <tr>
      <td><strong>Otra Cuenta :</strong></td>
      <td>${{ parseInt(transferencia + transferenciaMovimiento).toLocaleString("es-CO") }}</td>
    </tr>
  </table>
</p>      
      </div>
    </div>
  </div>
</template>
  
<script>
import Utiles from "../../Servicios/Utiles";
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";
import BusquedaEnFecha from "../Extras/BusquedaEnFecha.vue";

export default {
  components: { BusquedaEnFecha },
  data: () => ({
    totalIngresos: "",
    historialMovimientos: [],
    totalGastos: "",
    totalesGastos: [],
    totalesIngresos: [],
    valoresDetallados: [],
    movimientos: [],
    efectivo: 0,
    nequi: 0,
    transferencia: 0,
    tarjeta: 0,
    fechaInicio: "",
    fechaFin: "",
    efectivoMovimiento: 0,
    nequiMovimiento: 0,
    transferenciaMovimiento: 0,
    tarjetaMovimiento: 0,
    nequiComercial: 0,
    nequiComercialMovimiento: 0,
  }),
  mounted() {
    this.obtenerGastos();
    this.obtenerIngresos();
    this.obtenerValoresDetallados();
    // this.obtenerMovimientos();
    document.title = "Ingresos Y Egresos";
  },
  methods: {
    // obtenerMovimientos() {
    //   HttpService.obtenerConConsultas("reportes.php", {
    //     accion: "obtenerMovimientos",
    //   }).then((resultado) => {
    //     // Asignar el resultado a this.movimientos
    //     this.movimientos = resultado;
    //     // Mostrar this.movimientos en la consola
    //   });
    // },

    showSwal() {
      Swal.fire({
        title: "Movimiento de Dinero",
        html: `
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <label for="source" style="flex: 1;">Fuente:</label>
          <select id="source" class="swal2-select" style="flex: 2;">
            <option value="efectivo">Efectivo</option>
            <option value="nequi">Nequi</option>
            <option value="transferencia">Bancolombia</option>
            <option value="tarjeta">Bancolombia2</option>
            <option value="nequiComercial">Nequi Comercial</option>
          </select>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <label for="destination" style="flex: 1;">Destino:</label>
          <select id="destination" class="swal2-select" style="flex: 2;">
            <option value="efectivo">Efectivo</option>
            <option value="nequi">Nequi</option>
            <option value="transferencia">Bancolombia</option>
            <option value="tarjeta">Bancolombia2</option>
            <option value="nequiComercial">Nequi Comercial</option>
          </select>
        </div>
        <div style="display: flex; justify-content: center; margin-bottom: 10px;">
          <input type="number" id="amount" class="swal2-input" placeholder="Ingrese la cantidad" style="width: 50%;">
        </div>
      `,
        showCancelButton: true,
        confirmButtonText: "Mover",
        preConfirm: () => {
          const source = Swal.getPopup().querySelector("#source").value;
          const destination =
            Swal.getPopup().querySelector("#destination").value;
          const amount = Swal.getPopup().querySelector("#amount").value;
          if (!source || !destination || !amount) {
            Swal.showValidationMessage("Por favor complete todos los campos");
          }
          if (source === destination) {
            Swal.showValidationMessage(
              "Por favor seleccione opciones diferentes para Fuente y Destino"
            );
          }
          return { source: source, destination: destination, amount: amount };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const { source, destination, amount } = result.value;
          this.cargando = true;
          let payload = {
            accion: "movimientoDinero",
            source: source,
            destination: destination,
            amount: amount,
          };
          HttpService.registrar("reportes.php", payload)
            .then((registrado) => {
              if (registrado) {
                this.$buefy.toast.open({
                  type: "is-info",
                  message: "Movimiento de dinero Exitoso",
                });
                this.cargando = false;
              }
            })
            .catch(() => {
              this.$buefy.toast.open({
                type: "is-danger",
                message: "Hubo un error al registrar el movimiento",
              });
              this.cargando = false;
            });
        }
      });
    },
    redireccionar(ruta) {
      this.$router.push({
        name: ruta,
      });
    },
    obtenerValoresDetallados() {
      HttpService.obtenerConConsultas("reportes.php", {
        accion: "obtenerGastosPagos",
      }).then((resultado) => {
        this.valoresDetallados = resultado;

        // Inicializar sumas de ingresos y gastos
        let ingresosEfectivo = 0,
          ingresosNequi = 0,
          ingresosTransferencia = 0,
          ingresosTarjeta = 0,
          ingresosNequiComercial = 0;
        let gastosEfectivo = 0,
          gastosNequi = 0,
          gastosTransferencia = 0,
          gastosTarjeta = 0,
          gastosNequiComercial = 0;

        // Inicializar movimientos específicos
        this.efectivoMovimiento = 0;
        this.nequiMovimiento = 0;
        this.transferenciaMovimiento = 0;
        this.tarjetaMovimiento = 0;
        this.nequiComercialMovimiento = 0;

        // Sumar valores según el concepto
        this.valoresDetallados.forEach((item) => {
          if (item.concepto === "Ingreso") {
            ingresosEfectivo += parseFloat(item.efectivo || 0);
            ingresosNequi += parseFloat(item.nequi || 0);
            ingresosTransferencia += parseFloat(item.transferencia || 0);
            ingresosTarjeta += parseFloat(item.tarjeta || 0);
            ingresosNequiComercial += parseFloat(item.nequiComercial || 0);
          } else if (item.concepto === "Gasto") {
            gastosEfectivo += parseFloat(item.efectivo || 0);
            gastosNequi += parseFloat(item.nequi || 0);
            gastosTransferencia += parseFloat(item.transferencia || 0);
            gastosTarjeta += parseFloat(item.tarjeta || 0);
            gastosNequiComercial += parseFloat(item.nequiComercial || 0);
          }

          // Asignar valores a movimientos específicos si el id es 0
          if (item.id === 0) {
            this.efectivoMovimiento += parseFloat(item.movimientoEfectivo || 0);
            this.nequiMovimiento += parseFloat(item.movimientoNequi || 0);
            this.transferenciaMovimiento += parseFloat(
              item.movimientoTransferencia || 0
            );
            this.tarjetaMovimiento += parseFloat(item.movimientoTarjeta || 0);
            this.nequiComercialMovimiento += parseFloat(
              item.movimientoNequiComercial || 0
            );
          }
        });

        // Calcular las diferencias entre ingresos y gastos
        this.efectivo = ingresosEfectivo - gastosEfectivo;
        this.nequi = ingresosNequi - gastosNequi;
        this.transferencia = ingresosTransferencia - gastosTransferencia;
        this.tarjeta = ingresosTarjeta - gastosTarjeta;
        this.nequiComercial = ingresosNequiComercial - gastosNequiComercial;
      });
    },
    onBusquedaEnFecha(fechas) {
      this.fechaInicio = fechas[0].toISOString().split("T")[0];
      this.fechaFin = fechas[1].toISOString().split("T")[0];
      this.obtenerGastos();
      this.obtenerIngresos();
    },
    obtenerGastos() {
      let payload = {
        accion: "obtenerGastos",
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (resultado) => {
          this.totalesGastos = resultado;
          const total = resultado.reduce(
            (acumulador, gastos) => acumulador + parseFloat(gastos.totalVentas),
            0
          );
          this.totalGastos = total;
          this.crearGraficaGastos(this.totalesGastos);
        }
      );
    },
    crearGraficaGastos(array) {
      Utiles.generarGrafica(
        "pie",
        array,
        "#contenedor-gastos",
        "#grafica-gastos",
        "grafica-gastos"
      );
    },
    obtenerIngresos() {
      let payload = {
        accion: "obtenerIngresos",
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (resultado) => {
          this.totalesIngresos = resultado;
          const total = resultado.reduce(
            (acumulador, ingreso) =>
              acumulador + parseFloat(ingreso.totalVentas),
            0
          );
          this.totalIngresos = total;
          this.crearGraficaIngresos(this.totalesIngresos);
        }
      );
    },
    crearGraficaIngresos(array) {
      Utiles.generarGrafica(
        "pie",
        array,
        "#contenedor-ingresos",
        "#grafica-ingresos",
        "grafica-ingresos"
      );
    },
    mostrarHistorial() {
      let payload = {
        accion: "obtenerHistorialMovimiento",
      };
      HttpService.obtenerConConsultas("reportes.php", payload)
        .then((transacciones) => {
          this.historialMovimientos = transacciones.sort((a, b) => b.id - a.id);
          this.mostrarHistorialEnSwal();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    mostrarHistorialEnSwal() {
      const tableRows = this.historialMovimientos
        .map(
          (transaccion) => `
        <tr>
          <td>${transaccion.fuente}</td>
          <td>${transaccion.destino}</td>
          <td>${parseInt(transaccion.monto).toLocaleString("es-CO")}</td>
          <td>${new Date(transaccion.fecha).toLocaleString("es-CO")}</td>
        </tr>
      `
        )
        .join("");

      const tableHtml = `
        <table border="1" style="width: 100%; text-align: left; border-collapse: collapse;">
          <thead>
            <tr>
              <th>Fuente</th>
              <th>Destino</th>
              <th>Monto</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      `;

      Swal.fire({
        title: "Historial de Movimientos",
        html: tableHtml,
        width: "80%",
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: "Cerrar",
      });
    },
    handleButtonClick(event) {
      event.stopPropagation();
      this.mostrarHistorial();
    },
  },
};
</script>


<style scoped>
.column {
  position: relative;
  width: 100%; /* Ajusta según tus necesidades */
}
.manual-card {
  /* Estilos de tu tarjeta personalizada */
  background-color: #d2e7f1;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  padding: 2px;
  transition: all 0.3s ease; /* Efecto de transición al pasar sobre la tarjeta */
}

.manual-card:hover {
  /* Estilos cuando se pasa el cursor sobre la tarjeta */
  transform: translateY(-2px); /* Eleva ligeramente la tarjeta */
  background-color: #d3d6f7;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* Aumenta el efecto de sombra */
}

/* Estilos para el contenedor de gastos */
.gastos-box {
  background-color: #ffcccc; /* Rojo pastel */
}

/* Estilos para el contenedor de ingresos */
.ingresos-box {
  background-color: #ccffccaf; /* Verde pastel */
}
.Saldo-box {
  background-color: #97fd97af; /* Verde pastel */
}

#per{
  background-color: #d0fad0af; 
  box-shadow: 5px 5px 15px rgba(0, 128, 0, 0.8); /* Cambia a una sombra verde */
  transition: box-shadow 0.3s ease;
}

.Saldo-box.negative {
  background-color: #ff4d4d; /* Rojo */
}

.Saldo-box {
  cursor: pointer;
}
</style>